(function () {
  'use strict';

  angular
    .module('app.page-project-part-act-remark-template-types', []);
})();
